module.exports = __webpack_public_path__ + "static/img/fwzlBGC.a68eb313.png";